const shipper = [
  {
    index: 0,
    title: `Free Delivery`,
    desc: "Free shipping around the world for all ",
    desc2: " orders over $120",
    icon: "https://htmldemo.net/lukani/lukani/assets/img/about/shipping1.png",
  },
  {
    index: 1,
    title: `Safe Payment`,
    desc: `With our payment gateway, don't worry `,
    desc2: " about your information",
    icon: "https://htmldemo.net/lukani/lukani/assets/img/about/shipping2.png",
  },
  {
    index: 2,
    title: `Friendly Services`,
    desc: "You have 30-day return guarantee for ",
    desc2: " every single order",
    icon: "https://htmldemo.net/lukani/lukani/assets/img/about/shipping3.png",
  },
];

export default shipper;
